export const SET_IS_ENABLE_SEND_TO_EMPLOYER = "SET_IS_ENABLE_SEND_TO_EMPLOYER";

export interface Action {
  type: string;
  state: boolean;
}

export const setEnableSendToEmployer = (data: boolean) =>({
  type: SET_IS_ENABLE_SEND_TO_EMPLOYER,
  state: data,
})